import { LegalLayout, LegalSection } from "../components/LegalLayout";
import { restaurantInfo } from "../mock";

export default function Terms() {
  return (
    <LegalLayout
      title="Terms & Conditions"
      updated="January 2026"
      seo={{
        description: "Nina's Taqueria Terms & Conditions covering website use, menu pricing, ordering, intellectual property, and liability.",
        path: "/terms",
      }}
    >
      <LegalSection heading="1. Welcome">
        <p>
          By accessing or using the website of Nina's Taqueria, Inc. (“we,” “us,” “our”),
          you agree to these Terms &amp; Conditions. If you do not agree, please do not
          use the website.
        </p>
      </LegalSection>
      <LegalSection heading="2. Menu &amp; pricing">
        <p>{restaurantInfo.priceDisclaimer}</p>
        <p>
          Availability of items depends on the day and the season. We reserve the right
          to change our menu, ingredients, and prices at any time without prior notice.
        </p>
      </LegalSection>
      <LegalSection heading="3. Online orders">
        <p>
          Online ordering is provided through our third-party partner. When you place an
          order online, the terms of that provider also apply. We are not responsible for
          service disruptions or delays caused by the ordering platform.
        </p>
      </LegalSection>
      <LegalSection heading="4. Intellectual property">
        <p>
          All content on this website — including text, photos, menu descriptions, logos,
          and design — belongs to Nina's Taqueria, Inc. or is used with permission. You
          may not copy, republish, or redistribute this content without our written consent.
        </p>
      </LegalSection>
      <LegalSection heading="5. Allergens">
        <p>
          Our kitchen handles gluten, dairy, eggs, soy, and shellfish. While we make every
          effort to accommodate dietary restrictions, we cannot guarantee that any dish is
          free of cross-contact with allergens. Please let us know about your allergies.
        </p>
      </LegalSection>
      <LegalSection heading="6. Limitation of liability">
        <p>
          To the fullest extent permitted by law, Nina's Taqueria, Inc. is not liable for
          indirect, incidental, or consequential damages arising from your use of this
          website or our services.
        </p>
      </LegalSection>
      <LegalSection heading="7. Contact">
        <p>
          Questions about these terms? Email us at{" "}
          <a href={`mailto:${restaurantInfo.email}`} className="text-brand hover:underline">
            {restaurantInfo.email}
          </a>{" "}
          or call {restaurantInfo.phone}.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
